// Billing line quantities can be part of a pack (2.5 ml). The server stores two decimals, as MediKredit carries them.

/** Half-up to the cent. `toFixed(2)` is not half-up on binary floats (1.005 gives "1.00"). */
export const roundMoney = (value: number): number => Math.round((value + Number.EPSILON) * 100) / 100;

/** A line's quantity to two decimals; anything not above zero is 1. Same rule as the server's `lineQuantity`. */
export const lineQuantity = (value: unknown): number => {
  const quantity = roundMoney(Number(value));
  return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
};

/** "2", "2.5" or "2.5 ml": no trailing zeros, plus the unit the line counts in when it has one. */
export const formatLineQuantity = (item: { quantity?: unknown; quantityUnit?: string | null; [key: string]: unknown }): string => {
  const quantity = String(lineQuantity(item.quantity ?? 1));
  return item.quantityUnit ? `${quantity} ${item.quantityUnit}` : quantity;
};
